<template>
  <header class="header--wrap">
    <div class="header-description">
      <i class="icon icon--editmode"></i>
      <p class="mode-description"
         v-html="$t('group.editMode.description')"></p>
      <p class="data-date"
         v-html="$t('journey.basedOn', { date: dataTimeString, timezone: timezone })"></p>
    </div>
    <div class="header">
      <h2 class="logo" @click="toDashboard">
        <i class="icon icon--logo-horizontal"></i>
      </h2>
      <div class="title--area">
        <h2 v-html="$t('group.editMode.title')"></h2>
      </div>
    </div>
    <div class="button--area clearfix">
      <ui-button @click="onCancel">
        <i class="icon icon--exit"></i>
        {{ $t('common.exit') }}
      </ui-button>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex'
import { format } from 'date-fns'
import { EventBus } from '@/libs/event-bus'

import UiButton from '@/components/ui/UiButton'

export default {
  name: 'GroupHeader',
  components: {
    UiButton
  },
  computed: {
    ...mapState([
      'userData',
      'planData',
      'domain'
    ]),
    dataTimeString () {
      const loadedAt = new Date()
      const formatText = this.$t('journey.basedOnFormat')
      return format(loadedAt, formatText)
    }
  },
  data () {
    return {
      searching: false,
      timezone: null
    }
  },
  created () {
    EventBus.$on('onSearching', (value) => {
      this.searching = value
    })
    this.timezone = this.domain.timezone
  },
  methods: {
    onCancel () {
      EventBus.$emit('onCancelEdit')
    },
    toDashboard () {
      this.$router.push({ name: 'dashboard', query: { sid: this.$route.query.sid } })
    }
  }
}
</script>

<style lang="scss" scoped>
.header--wrap {
  position: relative;
  z-index: 100;

  .header-description {
    height: 38px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
    background-color: #d1ecff;
    border-bottom: 1px solid #b5defa;
    font-size: 12px;
    line-height: 1;
    color: #289eef;

    .icon {
      float: left;
      margin: 12px 0 0 8px;
    }

    .mode-description {
      float: left;
      padding: 14px 0 0 6px;
    }

    .data-date {
      float: right;
      padding: 14px 20px 0;
    }
  }

  .header {
    position: relative;
    z-index: 1;
    height: 58px;
    padding-left: 0;

    .logo {
      vertical-align: top;
      display: inline-block;
      position: relative;
      margin: 9px 0 0 17px;
      z-index: 10;
      cursor: pointer;
    }

    .title--area {
      vertical-align: top;
      display: inline-block;
      margin: 17px 0 0 17px;
      padding-left: 15px;
      height: 17px;
      border-left: 1px solid #aaaaaa;

      h2 {
        font-size: 20px;
        font-weight: 500;
        line-height: 1;
        color: #289eef;
      }
    }
  }

  .button--area {
    position: absolute;
    z-index: 30;
    top: 52px;
    right: 30px;

    .ui-btn {
      margin-left: 5px;

      /deep/ .icon {
        vertical-align: middle;
        margin: -2px 8px 0 -2px;
      }
    }

    &::before {
      content: "";
      display: inline-block;
      vertical-align: middle;
      width: 1px;
      height: 20px;
      background-color: #d7d7d7;
      margin: -4px 6px 0 0;
    }
  }
}
</style>
